<template>
  <div v-if="isSmacAdmin" id="export-csv-container">
    <button
      type="button"
      class="export-csv-button"
      @click="toggleActionModal(true, 'export-raw')"
    >
      <span>Export CSV </span>
    </button>
  </div>
</template>

<script>

import customerDetailMixin from '@shared/mixins/customerDetailMixin';

export default {
  name: 'ExportCSVButton',
  mixins: [customerDetailMixin],
};
</script>

<style lang="scss">

#export-csv-container {
margin-right: 6px;
user-select: none;
.export-csv-button {
    min-width: 108px;
    height: 32px;
    background-color: $NBLUE100;
    display: flex;
    align-items: center;
    justify-content: center;
    color: $WHITE;
    font-size: 12.64px;
    &:disabled {
    background-color: $N50
    };
    .loading {
    width: 20px;
    }
}
}
</style>
